import {
	Component
} from 'react';

export class Lobby extends Component {
	render(){
		return null;
	}
}
